import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { scroller } from 'react-scroll/modules';
import { withRouter } from 'react-router-dom';
import intl from 'react-intl-universal';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { FormControlLabel } from 'material-ui/Form';
// import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";


import { NotFound } from '..';
import { Box, Button, ClipboardInput, DotLoader, Loader, ContextMenu, ContextMenuItem, ContextMenuTrigger } from 'components'; // BannerAd
import { ImageresizeApi } from 'modules';

import ShareIcon from 'assets/icons/share.svg';
import WarningIcon from 'assets/icons/warning.svg';

import styles from './styles';

class ViewImage extends PureComponent {
  state = {
    version: 'v2',
    reportDialogState: null,
    reportValue: 'spam',
    imagePermalink: null,
    isMobile: false
  };

  scrollToShareLinks = () => {
    scroller.scrollTo('shareLinks', {
      duration: 500,
      smooth: true
    });
  };

  openReportDialog = () => this.setState({
    reportDialogState: 'open'
  });

  closeReportDialog = () => this.setState({
    reportDialogState: null
  });

  handleReportChange = (event, value) => this.setState({
    reportValue: value
  });

  submitReport = () => {
    const { match } = this.props;
    const { reportValue, version } = this.state;

    this.setState({
      reportDialogState: 'loading'
    });

    ImageresizeApi.reportImage(match.params.imageId, reportValue, version)
      .then(() => this.setState({
        reportDialogState: 'success'
      }))
      .catch(() => this.setState({
        reportDialogState: 'error'
      }));
  };

  componentDidMount() {
    const { match } = this.props;
    this.setState({
      version: match.path.match(/\/view+/) ? 'v2' : 'v1',
      isMobile: window.innerWidth < 550
    });

    ImageresizeApi.requestImageMetadata(match.params.imageId, this.state.version)
      .then((response) => this.setState({
        imagePermalink: response.permalink
      }))
      .catch(() => this.setState({
        imagePermalink: 'error'
      }));
  }

  renderReportDialogContent() {
    const { reportDialogState } = this.state;

    if (reportDialogState === 'loading') {
      return (
        <DialogContent>
          <DotLoader />
        </DialogContent>
      );
    }

    if (reportDialogState === 'error') {
      return (
        <React.Fragment>
          <DialogContent>
            <DialogContentText>
              {intl.get('Failed to report the image, please try again later.')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="main-button"
              onClick={this.closeReportDialog}
            >
              {intl.get('Okay')}
            </Button>
          </DialogActions>
        </React.Fragment>
      );
    }

    if (reportDialogState === 'success') {
      return (
        <React.Fragment>
          <DialogContent>
            <DialogContentText>
            {intl.get('Successfully reported the image.')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              className="main-button"
              onClick={this.closeReportDialog}
            >
              {intl.get('Okay')}
            </Button>
          </DialogActions>
        </React.Fragment>
      );
    }
    
    return (
      <React.Fragment>
        <DialogContent>
          <DialogContentText>
            {intl.get('View.ReportCauseQuestion')}
          </DialogContentText>
          <RadioGroup
            aria-label="report type"
            name="reportType"
            value={this.state.reportValue}
            onChange={this.handleReportChange}
          >
            <FormControlLabel value="spam" control={<Radio />} label={intl.get('View.SpamContent')} />
            <FormControlLabel value="adult_or_illegal" control={<Radio />} label={intl.get('View.AdultOrIllegalContent')} />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button
            className="main-button"
            onClick={this.submitReport}
          >
            {intl.get('Report')}
          </Button>
        </DialogActions>
      </React.Fragment>
    )
  }

  renderImage() {
    const { match } = this.props;
    const imageUrl = ImageresizeApi.getImageDirectUrl(match.params.imageId);
    if(this.state.isMobile) {
      return (
        <img
          className={styles.previewImage}
          src={imageUrl}
          alt="Result"
        />
      )
    } else {
      return (
        <div>
          <ContextMenuTrigger id="img-menu">
            <img
              className={styles.previewImage}
              src={imageUrl}
              alt="Result"
            />
          </ContextMenuTrigger>
  
          <ContextMenu id="img-menu" className="embed-menu">
            <ContextMenuItem>
              <Box className={styles.shareLinks}>
                <h2>{intl.get('Embed This Image')}</h2>
                <ClipboardInput
                  value={`<a href="${ImageresizeApi.BASE_URL}${this.props.location.pathname}" target="_blank"><img src="${this.state.imagePermalink}" title="Resized using imageresize.org" border="0" /></a>`}
                />
                <p>{intl.get('Copy & Paste this code in your HTML')}</p>
              </Box>
            </ContextMenuItem>
          </ContextMenu>
        </div>
      )
    }
  }
  renderShareLinks() {
    const { imagePermalink } = this.state;

    if (!imagePermalink) {
      return <Loader text={false} />;
    }

    if (imagePermalink === 'error') {
      return (
        <Box>
          {intl.get('View.FailedLoadingLink')}
        </Box>
      );
    }

    return (
      <Box className={styles.shareLinks}>
        <h2>{intl.get('View.ImageLinks')}</h2>
        <ClipboardInput
          label={intl.get('View.DirectLink')}
          value={`${ImageresizeApi.BASE_URL}${this.props.location.pathname}`}
        />
        <ClipboardInput
          label={intl.get('View.HTMLImage')}
          value={`<a href="${ImageresizeApi.BASE_URL}${this.props.location.pathname}" target="_blank"><img src="${imagePermalink}" title="Resized using imageresize.org" border="0" /></a>`}
        />
        <ClipboardInput
          label={intl.get('View.BBCode')}
          value={`[URL=${ImageresizeApi.BASE_URL}${this.props.location.pathname}][IMG]${imagePermalink}[/IMG][/URL]`}
        />
        <ClipboardInput
          label={intl.get('View.ImageLink')}
          value={imagePermalink}
        />
      </Box>
    );
  }

  render() {
    if (this.state.imagePermalink === 'error') {
      return <NotFound />
    } else if (this.state.imagePermalink) {

      return [
        <Helmet key="viewimage-helmet">
          <title>{intl.get('View.PageHeader')}</title>
          <meta
            name="description"
            content={intl.get('View.PageHeaderDescription')}
          />
          <meta
            name="robots"
            content="noindex"
          />
        </Helmet>,
        // <BannerAd key="viewimage-bannerad" />,
        <div className="container" key="viewimage-container">
          <div className={styles.header}>
            <h2>{intl.get('This image was saved by a user via ImageResize.org')}</h2>
            <Button
              className={styles.headerButton}
              onClick={this.scrollToShareLinks}
            >
              <ShareIcon className={styles.headerIcon} height="24" width="24" />
              {intl.get('Share Links')}
            </Button>
            <Button
              className={styles.headerButton}
              onClick={this.openReportDialog}
            >
              <WarningIcon className={styles.headerIcon} height="24" width="24" />
              {intl.get('Report Image')}
            </Button>
          </div>
          {this.renderImage()}
          {/* <BannerAd /> */}
          <div
            className="section"
            ref={(elem) => {
              scroller.register('shareLinks', elem);
            }}
          >
            {this.renderShareLinks()}
          </div>
        </div>,
        <Dialog
          key="viewimage-report-dialog"
          open={!!this.state.reportDialogState}
          onClose={this.closeReportDialog}
          aria-labelledby="report-image-title"
        >
          <DialogTitle id="report-image-title">{intl.get('Report Image')}</DialogTitle>
          {this.renderReportDialogContent()}
        </Dialog>
      ];
    } else {
      return '';
    }
  }
}

export default withRouter(ViewImage);



// WEBPACK FOOTER //
// ./src/containers/ViewImage/index.jsx